import { defineEvent } from '../types/event';
export var PRODUCT_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'View_Product'
        },
        {
            name: 'GTM',
            alias: 'viewProduct'
        }
    ]
});
